import './InfiniteList.scss';

import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface Props<T> {
  renderItem: (item: T, index: number) => React.ReactElement | null;
  data: T[];
  isLoading: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
}

const InfiniteList = <T,>(props: Props<T>) => {
  const { data, fetchNextPage, isFetchingNextPage, isLoading, renderItem } = props;

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView]);

  return (
    <div className="InfiniteList">
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <>
          {data.map((item, index) => renderItem(item, index))}
          {isFetchingNextPage && <LoadingIndicator />}
          <div ref={ref} />
        </>
      )}
    </div>
  );
};

export default InfiniteList;
